<template>
  <a-form-item
    :label="data.fieldname"
    class="input-group"
  >
    <a-input
      v-model="value.min"
      :placeholder="placeholder"
      :disabled="data.disabled"
      class="input"
      @change="handleInput1(value.min, value.max)"
    />
    <span>~</span>
    <a-input
      v-model="value.max"
      :placeholder="placeholder"
      :disabled="data.disabled"
      class="input"
      @change="handleInput2(value.min, value.max)"
    />
  </a-form-item>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      value: {
        min: '',
        max: ''
      },
      placeholder: this.$t('message["804"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        const { fieldvalue = {} } = this.data
        const { min = '', max = '' } = fieldvalue
        this.value.min = min
        this.value.max = max
      },
      immediate: true
    }
  },
  methods: {
    handleInput1 (min, max) {
      this.value.min = min
      this.value.max = max
      this.$emit('change', this.value)
    },
    handleInput2 (min, max) {
      this.value.min = min
      this.value.max = max
      this.$emit('change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  width: 150px;
}
span {
  margin: 0 5px;
}
</style>
